import { ApplianceApertureIdentifier } from "$src/CGS/domain/dto/core/bones/ApplianceApertureIdentifier";
import { InsideElementMetadata, FrontFacePlacementMetadata } from "./InsideElementMetadata";

export class ApplianceInsideMetadata extends InsideElementMetadata {
    BonePlacement?: FrontFacePlacementMetadata;
    ApplianceApertureIdentifier?: ApplianceApertureIdentifier;
}
